import React from 'react';
import { T } from 'shared/helper/translate';
import { trackServiceClick } from 'rubriq/helpers/navbarTracking';
import { NAVBAR_TRACKING } from '../../constants';
var Link = function Link(_ref) {
  var link = _ref.link,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    setShowMobileMenu = _ref.setShowMobileMenu,
    _ref$currentPage = _ref.currentPage,
    currentPage = _ref$currentPage === void 0 ? NAVBAR_TRACKING.home : _ref$currentPage;
  return /*#__PURE__*/React.createElement("div", {
    className: "link-container"
  }, /*#__PURE__*/React.createElement("a", {
    href: link.url,
    target: "_self",
    rel: "noreferrer",
    className: "dropdown-item icon-bullet-link ".concat(className),
    onClick: function onClick() {
      trackServiceClick(link.text, currentPage);
      setShowMobileMenu === null || setShowMobileMenu === void 0 || setShowMobileMenu(false);
    }
  }, /*#__PURE__*/React.createElement(T, {
    source: link.text
  })), link.isPopular && /*#__PURE__*/React.createElement("span", {
    className: "popular-tag"
  }, /*#__PURE__*/React.createElement(T, {
    source: "popular"
  })));
};
export default Link;